export const Aspects = [
    {
        id: 1,
        title: "Experience",
        desc: "We are an experienced web development company in Nagpur that has gained immense appreciation from its past and present customers. Our team of web designers keeps themselves updated with the latest designing trends to deliver you a fresh and amazing website. We never go below the mark and always there to help our customers to make their brand the talk of the town."
    },
    // {
    //     id: 2,
    //     title: "Team",
    //     desc: "As the best web design company in Nagpur, we hire people with the right skill set to help your business gain online success. Our team of web designers stays in contact with you while designing your website so that not even a tiniest detail is missed out. We understand your ideas that you have for your website and incorporate the same into your web design. Our team ensures that your website truly represents what your brand is all about and swiftly reaches your target audience to give a boost to your sales and revenue."
    // },
    {
        id: 3,
        title: "Cost-effective",
        desc: "We are the most affordable web design agency in Nagpur. As an expert we offers the best web designing solutions that can turn your business into a recognized brand over the digital platform. We serve the web designing need of every business cost-effectively."
    },
    {
        id: 4,
        title: "Website portfolio",
        desc: "By seeing our website portfolio, you will know that what we are saying are not mere words. Get a glimpse of some of our best works and get one for yourself. As a reputed website designing company in Nagpur, we deliver websites that differentiate your brand online and bring more traffic and leads to your business."
    },
    {
        id: 5,
        title: "Copywriting",
        desc: "The content of a website plays a crucial role in making it an online success. Our experts create compelling and SEO-friendly content for your website by targeting the right keywords. We leave no stone untouched to bring the best to your business."
    },
    {
        id: 6,
        title: "Landing Page Design And Optimization",
        desc: "As an experienced web design company in Nagpur, we do everything it takes to make your landing page convert. We use the best design elements, ad copy, and calls to action to enhance your website’s performance. By designing and optimizing your landing page, we ensure that good quality traffic comes to your virtual doorstep and helps you boost your sales and revenue."
    },
    {
        id: 7,
        title: "Style",
        desc: "At Bluecoder (top web design company in Nagpur), we have designers that can design websites with both minimalistic and bright & bold looks. Depending on your business requirements, we create custom web designing solutions that help you turn your ideas into digital designs."
    },
    {
        id: 8,
        title: "Time commitment",
        desc: "As a reliable web development company in Nagpur, we plan out a specific timeline and keep the same in mind to deliver your project on time. Our experts ensure that every work done on your website goes smoothly, and it performs efficiently on the digital platform."
    }
];

export default Aspects